import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ComorosFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14531'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14531)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#FFCB49'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2667H20V6.53333H0V10.2667Z'
					fill='#DC1D34'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#4985D4'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14L9.52381 7L0 0V14Z'
					fill='#4BA343'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.81027 9.79995C4.05691 9.79995 4.29625 9.76932 4.52456 9.71174C3.29225 9.40091 2.3817 8.30464 2.3817 6.99995C2.3817 5.69526 3.29225 4.59899 4.52455 4.28816C4.29625 4.23058 4.05691 4.19995 3.81027 4.19995C2.23231 4.19995 0.953125 5.45355 0.953125 6.99995C0.953125 8.54635 2.23231 9.79995 3.81027 9.79995ZM5.71503 5.13328C5.71503 5.39102 5.50183 5.59995 5.23884 5.59995C4.97585 5.59995 4.76265 5.39102 4.76265 5.13328C4.76265 4.87555 4.97585 4.66662 5.23884 4.66662C5.50183 4.66662 5.71503 4.87555 5.71503 5.13328ZM5.23884 7.46662C5.50183 7.46662 5.71503 7.25768 5.71503 6.99995C5.71503 6.74222 5.50183 6.53328 5.23884 6.53328C4.97585 6.53328 4.76265 6.74222 4.76265 6.99995C4.76265 7.25768 4.97585 7.46662 5.23884 7.46662ZM5.71503 8.86662C5.71503 9.12435 5.50183 9.33328 5.23884 9.33328C4.97585 9.33328 4.76265 9.12435 4.76265 8.86662C4.76265 8.60888 4.97585 8.39995 5.23884 8.39995C5.50183 8.39995 5.71503 8.60888 5.71503 8.86662Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default ComorosFlagIcon;
